interface Props {
  isActivePlayer: boolean;
  activeNickname?: string;
}

export function MysteryTrack({ isActivePlayer, activeNickname }: Props) {
  const label = isActivePlayer
    ? "Écoutez… où placez-vous ce titre ?"
    : `${activeNickname ?? "Un joueur"} écoute l'extrait…`;

  return (
    <div
      className="fixed top-[4.25rem] left-3 md:left-6 z-40 flex items-center gap-2.5 cw-panel px-3 py-2 shadow-lg max-w-[min(18rem,calc(100vw-1.5rem))]"
      aria-live="polite"
      aria-label={label}
    >
      <div className="relative w-11 h-11 shrink-0">
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-violet-600 to-blue-600 opacity-35 blur-md" />
        <div className="relative w-full h-full rounded-full border-2 border-violet-400/50 flex items-center justify-center vinyl-spin">
          <div className="w-2.5 h-2.5 rounded-full bg-orange-400" />
        </div>
      </div>

      <div className="flex flex-col gap-1 min-w-0">
        <div className="flex gap-0.5 h-3.5 items-end" aria-hidden>
          {[0, 1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="w-0.5 bg-violet-400 rounded wave-pulse"
              style={{ animationDelay: `${i * 0.15}s`, height: `${8 + i * 3}px` }}
            />
          ))}
        </div>
        <p className="text-violet-200/90 text-xs leading-snug">{label}</p>
      </div>
    </div>
  );
}
